var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBellNotification = function SvgBellNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 70
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "M43.077 59.317c0-5.902-4.782-10.683-10.705-10.683s-10.704 4.781-10.704 10.683C21.668 65.218 26.449 70 32.372 70s10.705-4.782 10.705-10.683"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "M33.492 11.415a5.7 5.7 0 0 1-6.72-4.458c-.624-3.08 1.379-6.095 4.48-6.72a5.7 5.7 0 0 1 6.72 4.458c.625 3.102-1.378 6.117-4.48 6.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50CDFF",
    d: "M56.71 60.76H7.906c-4.373 0-8.551-7.366-4.825-9.24 6.16-3.08.883-.948 1.508-1.874L6.16 48.44c3.618-2.778 3.08-9.348 3.08-13.785V26.73c0-11.674 10.985-21.15 23.24-21.15s22.917 9.476 22.917 21.15v8.056c0 4.35-.43 10.855 3.08 13.633l1.53 1.207c1.83 1.443 1.55 2.67 1.55 4.932-.022 4.221-.474 6.203-4.846 6.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A4E0",
    d: "M58.692 60.76H5.923A5.92 5.92 0 0 1 0 54.837v-.452a5.92 5.92 0 0 1 5.923-5.923h52.77a5.92 5.92 0 0 1 5.922 5.923v.452a5.92 5.92 0 0 1-5.923 5.923"
  }))));
};
export default SvgBellNotification;